import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '../services/constants';

import api from '../services/api';

import { useSelector } from 'react-redux';
import { userSelector } from '../features/user/userSlice';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import LanguageIcon from '@mui/icons-material/Language';

function LanguageSelector(props) {
  const { t, i18n } = useTranslation();

  const { user } = useSelector(userSelector);

  const { isMobile } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (language) => {
    if (user) {
      api
        .patch('/users/change-language', { language })
        .then((res) => {
          // if (res.status === 200) {
          //   console.log('success', res.data);
          // }
        })
        .catch((err) => {
          // console.log('error', err);
        });
    }
    i18n.changeLanguage(language);
    handleClose();
  };

  return (
    <>
      {isMobile ? (
        <IconButton
          color="inherit"
          // sx={{ px: 2, ml: 1 }}
          sx={{ borderRadius: '4px', width: '48px', height: '48px', ml: 1 }}
          aria-controls="language"
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
          onClick={handleOpen}
        >
          <LanguageIcon />
        </IconButton>
      ) : (
        <Button
          color="inherit"
          sx={{ px: 2, ml: 1 }}
          aria-controls="language"
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
          onClick={handleOpen}
          startIcon={<LanguageIcon />}
        >
          {t(i18n.language)}
        </Button>
      )}
      <Menu
        id="language"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map((language) => (
          <MenuItem
            key={language}
            onClick={() => handleClick(language)}
            style={{
              fontWeight: i18n.language === language ? 'bold' : 'normal',
            }}
            sx={{ py: 2 }}
          >
            {t(language)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default LanguageSelector;
